module.exports = __webpack_public_path__ + "static/media/logo-centro-energia.06558cfd.png";